import { ChartWidgetMetadata } from '@/modules/ta/widget/models/metadata/ChartWidgetMetadata';
import { DataGridDrawOption } from '@/modules/ta/widget/models/drawoptions/DataGridDrawOption';
import { DatagridReportDisplayLengthKeys } from '@/modules/ta/widget/builder.constants';

export class DataGridWidgetMetadata extends ChartWidgetMetadata {
  fields_to_embed_sparklines;

  /**
   * @var {Array}
   */
  comparison_overwrite;

  constructor(model = {}) {
    super(model);

    this.draw_options = new DataGridDrawOption(model.draw_options);
    this.fields_to_embed_sparklines = model.fields_to_embed_sparklines;
    this.comparison_overwrite = model.comparison_overwrite || [];
  }

  get sparkline_fields() {
    const fields = this.fields_to_embed_sparklines;
    if (Array.isArray(fields) && fields.length) {
      return fields[0].values || [];
    }
    return [];
  }

  set sparkline_fields(value) {
    this.fields_to_embed_sparklines = [];
    this.fields_to_embed_sparklines.push({
      values: value,
    });
  }

  getPaginationOffset(isExporting = false) {
    const { grid_paginate, display_length, report_display_length } = this.draw_options;

    if (isExporting && grid_paginate) {
      switch (report_display_length) {
        case DatagridReportDisplayLengthKeys.DEFAULT:
        case DatagridReportDisplayLengthKeys.DEFAULT_OUI:
          return 100;

        default:
          return report_display_length;
      }
    }

    return this.lengthIsDefault(display_length) ? 10 : display_length;
  }

  lengthIsDefault(length) {
    return [
      DatagridReportDisplayLengthKeys.DEFAULT,
      DatagridReportDisplayLengthKeys.DEFAULT_OUI,
    ].includes(length);
  }
}
